import * as React from 'react';
import onClickOutside from 'react-onclickoutside';
import classnames from 'classnames';

import { appURLs } from '@utils/AppUtil';
import { getFormattedDeviceDetails } from '@utils/DeviceDetailsUtil';
import { track } from '@utils/MixPanelUtils';

interface IUserProfileSectionProps {
  auth: IAuthStore;
  redirectTo: (url: string) => (e: React.SyntheticEvent<any>) => void;
  logout: (e: React.SyntheticEvent<any>) => void;
  openDelegateWorkModal: () => void;
  isWorkDelegationOn: boolean;
}

interface IUserProfileSectionState {
  show: boolean;
}

class UserProfileSection extends React.Component<IUserProfileSectionProps, IUserProfileSectionState> {
  constructor(props: IUserProfileSectionProps) {
    super(props);

    this.state = { show: false };
  }

  handleClickOutside = (e: any) => {
    this.closeDropdown();
  };

  toggleDropdown = () => this.setState((prevState) => ({ show: !prevState.show }));

  closeDropdown = () => this.setState({ show: false });

  renderUserProfileTitle = (): any => {
    const { userProfile } = this.props.auth;

    return (
      <div onClick={this.toggleDropdown} className={classnames('app-header__user-name')}>
        <label>{`${userProfile.firstName} ${userProfile.lastName}`}</label>
        <div className={classnames('app-header__user-name-caret')} />
      </div>
    );
  };

  redirectTo = (url: string) => (e: any) => {
    this.closeDropdown();
    if (e.ctrlKey || e.shiftKey || e.metaKey || e.button || e.button === 1) {
      return;
    }
    this.props.redirectTo(url)(e);
  };

  logout = (e: React.SyntheticEvent<any>) => {
    this.closeDropdown();
    this.props.logout(e);
  };

  openDelegateWorkModal = (e: React.SyntheticEvent<HTMLLabelElement>) => {
    track('DELEGATE_WORK_CLICKED', {
      'Device Details': getFormattedDeviceDetails(),
    });
    this.props.openDelegateWorkModal();
    this.closeDropdown();
  };

  render() {
    const { auth, isWorkDelegationOn } = this.props;
    const agencyId = auth.userProfile.agencyId;

    return (
      <>
        <div
          className={classnames('app-header__user-profile', {
            'app-header__user-profile--visible': this.state.show,
          })}
        >
          {this.renderUserProfileTitle()}
          <div className={classnames('app-header__user-actions')}>
            {!auth.isSuperAdmin && (
              <>
                <a href={`/agencies/${agencyId}/${appURLs.profilePartialURL}`}>
                  <label onClick={this.redirectTo(appURLs.profilePartialURL)}>My Profile</label>
                </a>
                <label onClick={this.openDelegateWorkModal}>
                  Delegate Work
                  <span
                    key={2}
                    className={classnames('chip', {
                      off: !isWorkDelegationOn,
                    })}
                  >
                    {isWorkDelegationOn ? 'ON' : 'OFF'}
                  </span>
                </label>
              </>
            )}
            <label onClick={this.logout}>Logout</label>
          </div>
        </div>
      </>
    );
  }
}

export default onClickOutside(UserProfileSection);
